import { ROUTES } from "@/constants/routes";
import { useOpenSettings } from "@/context/OpenSettingsContext";
import { useAppNavigate } from "@/hooks/pane-routing";
import { useAppFlags } from "@/providers/LaunchDarklyProvider";
import { route } from "@/utils/route";
import { useCallback } from "react";

/**
 * Opens `ConnectionPane` for an integration id in the right pane — or Connectors, once the
 * integrations directory is off for it.
 */
export function useOpenConnection() {
  const appNavigate = useAppNavigate();
  const openSettings = useOpenSettings();
  const { legacyIntegrations, connectors } = useAppFlags();

  return useCallback(
    (integrationId: string) => {
      if (!integrationId) return;
      if (!legacyIntegrations && connectors) {
        openSettings(ROUTES.SETTINGS.CONNECTORS);
        return;
      }
      appNavigate({
        pane: "rightPane",
        to: route(ROUTES.SETTINGS.INTEGRATION_SETTINGS, { integrationId }),
      });
    },
    [appNavigate, openSettings, legacyIntegrations, connectors],
  );
}
